import {
  CenterSpinner
} from "./chunk-DE7BOQ75.mjs";
import {
  Close_default
} from "./chunk-JFT5CIYR.mjs";
import {
  ChevronSmallDown_default
} from "./chunk-2JTDUHVO.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/select/Select.tsx
import { useSelect } from "downshift";
import React, { useEffect, useRef } from "react";
var selectClassNames = "block w-full cursor-pointer appearance-none overflow-hidden rounded border border-[theme(backgroundColor.interactive-surface)] bg-interactive-surface bg-clip-border px-4 py-[10px] text-foreground-subtle caret-[theme(backgroundColor.interactive-accent-surface-active)] transition-colors duration-300 ease-out my-body-md focus-within:bg-surface focus-within:outline-none";
var Select = React.forwardRef(
  ({
    options,
    value,
    onChange,
    ariaLabel,
    disabled = false,
    error = false,
    positive = false,
    isLoading = false,
    clearable = false,
    startOpen = false,
    autoFocus = false,
    placeholder = "Select...",
    maxDropdownHeight = 900,
    className
  }, ref) => {
    const {
      isOpen,
      selectedItem,
      getToggleButtonProps,
      getMenuProps,
      highlightedIndex,
      getItemProps,
      reset
    } = useSelect({
      items: options,
      itemToString: (item) => (item == null ? void 0 : item.label) || "",
      initialSelectedItem: value,
      onSelectedItemChange: onChange,
      initialIsOpen: startOpen
    });
    const buttonRef = useRef(null);
    useEffect(() => {
      if (buttonRef && (buttonRef == null ? void 0 : buttonRef.current)) {
        if (autoFocus) {
          buttonRef.current.focus();
        }
      }
    }, [buttonRef, autoFocus]);
    return /* @__PURE__ */ React.createElement("div", { className: "relative w-full", ref }, /* @__PURE__ */ React.createElement(
      "button",
      __spreadProps(__spreadValues({
        type: "button",
        "aria-label": ariaLabel
      }, getToggleButtonProps({ ref: buttonRef })), {
        className: cn(
          selectClassNames,
          {
            "text-foreground-disabled focus:outline-none": disabled,
            "border-semantic-success": positive,
            "border-semantic-critical": error
          },
          className
        )
      }),
      /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between" }, /* @__PURE__ */ React.createElement("div", { className: "relative flex flex-shrink flex-grow flex-nowrap items-center overflow-hidden" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cn(
            "ml-[2px] h-full max-w-full overflow-hidden overflow-ellipsis whitespace-nowrap"
          )
        },
        (selectedItem == null ? void 0 : selectedItem.label) || placeholder
      )), /* @__PURE__ */ React.createElement("div", { className: "relative flex flex-shrink-0 items-center self-stretch" }, clearable && selectedItem && /* @__PURE__ */ React.createElement(
        "div",
        {
          tabIndex: -1,
          onClick: (e) => {
            e.stopPropagation();
            reset();
          },
          "aria-label": "clear selection",
          className: "mr-1 text-foreground"
        },
        /* @__PURE__ */ React.createElement(Close_default, { width: 18 })
      ), isLoading && /* @__PURE__ */ React.createElement("div", { className: "mr-1 cursor-wait" }, /* @__PURE__ */ React.createElement(CenterSpinner, { size: 20 })), /* @__PURE__ */ React.createElement(ChevronSmallDown_default, { className: "shrink-0" })))
    ), /* @__PURE__ */ React.createElement("div", { className: "absolute z-10 w-full" }, /* @__PURE__ */ React.createElement(
      "ul",
      __spreadValues({
        className: cn(
          "relative m-0 mt-1 w-full min-w-[300px] list-none space-y-1 overflow-auto rounded border bg-interactive-subtle-surface px-0 shadow-lg focus:outline-none",
          {
            "hidden opacity-0": !isOpen,
            "visible opacity-100": isOpen
          }
        ),
        style: {
          maxHeight: maxDropdownHeight
        }
      }, getMenuProps()),
      isOpen && options.map((item, index) => /* @__PURE__ */ React.createElement(
        "li",
        __spreadValues({
          key: `${item.id}${index}`,
          className: cn(
            "cursor-pointer bg-interactive-subtle-surface px-4 py-2 text-foreground transition-all my-body-sm duration-200 ease-in-out hover:bg-interactive-subtle-surface-hover",
            {
              "bg-interactive-subtle-surface-hover": highlightedIndex === index
            }
          )
        }, getItemProps({ item, index })),
        item.label
      ))
    )));
  }
);

export {
  selectClassNames,
  Select
};
